import React from 'react';

import logo from 'assets/img/logoname.png';

function LogoName() {
  return <img width="100%" height="100px" style={{ objectFit: 'contain' }} src={logo} alt="SL Diamonds" />;
  // return <img width="100%" height="50px" style={{ objectFit: 'contain' }} src={logo} alt="SL Diamonds" />;
}

export default LogoName;
